<template>
  <step-block
    class="step-block--material"
    v-bind="$attrs"
    v-on="$listeners"
    :title="name"
    :cover-image="photo"
    :attributes="attributes"
  />
</template>

<script>
  export default {
    name: 'MaterialBlock',
    props: {
      id: {},
      name: String,
      photo: String,
      attributes: {
        type: Array,
        default: () => [],
      },
    },
  };
</script>
